<template>
  <transition name="cookie-slide">
    <div v-if="visible" class="cookie-banner">
      <div class="container cookie-inner">
        <div class="cookie-text">
          Мы используем cookie-файлы, а также сервисы веб-аналитики, чтобы сайт работал
          корректно и был удобным. Продолжая, вы соглашаетесь с
          <router-link to="/terms">пользовательским соглашением</router-link> и
          <router-link to="/privacy">политикой конфиденциальности</router-link>.
        </div>
        <div class="cookie-actions">
          <button class="cookie-btn ghost" @click="decline">Отклонить</button>
          <button class="cookie-btn primary" @click="accept">Принять</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const STORAGE_KEY = 'mvk_cookie_consent'

export default {
  name: 'CookieBanner',
  data() {
    return { visible: false }
  },
  mounted() {
    // Показываем только если пользователь ещё не давал ответ
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      if (!saved) {
        // Небольшая задержка, чтобы баннер не «прыгал» при загрузке
        setTimeout(() => { this.visible = true }, 600)
      }
    } catch (e) {
      // Если localStorage недоступен — просто не показываем
    }
  },
  methods: {
    accept() {
      try { localStorage.setItem(STORAGE_KEY, 'accepted') } catch (e) { /* no-op */ }
      this.visible = false
    },
    decline() {
      try { localStorage.setItem(STORAGE_KEY, 'declined') } catch (e) { /* no-op */ }
      this.visible = false
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1100;
  background: #1f2933;
  color: #f8fafc;
  padding: 16px 0;
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.25);
}
.cookie-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}
.cookie-text {
  font-size: 0.9rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.85);
  max-width: 760px;
}
.cookie-text a {
  color: #ff8a7a;
  text-decoration: none;
  border-bottom: 1px dashed rgba(255, 138, 122, 0.5);
}
.cookie-text a:hover { color: #ffffff; }
.cookie-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}
.cookie-btn {
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.2s ease;
}
.cookie-btn.primary {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: #fff;
}
.cookie-btn.primary:hover { transform: translateY(-1px); }
.cookie-btn.ghost {
  background: transparent;
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.35);
}
.cookie-btn.ghost:hover { background: rgba(255, 255, 255, 0.08); }

.cookie-slide-enter-active, .cookie-slide-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}
.cookie-slide-enter-from, .cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media (max-width: 640px) {
  .cookie-inner { flex-direction: column; align-items: stretch; }
  .cookie-actions { width: 100%; }
  .cookie-btn { flex: 1; }
}
</style>
